import { render, staticRenderFns } from "./PassengerSearchDialog.vue?vue&type=template&id=bf24a62c&scoped=true&"
import script from "./PassengerSearchDialog.vue?vue&type=script&lang=js&"
export * from "./PassengerSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24a62c",
  null
  
)

export default component.exports